import React, { Component } from 'react'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend';
import { Link } from 'react-router-dom'
import { FormattedMessage, FormattedDate } from 'react-intl'
import StandardList from '../common/listing/list.component.jsx'
import SideBar from '../common/layout/sidebar.component.jsx'
import LoadingSpinner from '../common/spinner/loading.component.jsx'
import Icon from "../common/icon/icon.component.jsx"
import SalesToolsTabs from '../common/layout/tabs/salestools.component.jsx';
import GlobalHelper from "../common/GlobalHelper.jsx";
import CalendarStatusBadge from "../calendar/status.component.jsx";
import CalendarVisibilityBadge from "../calendar/calendarvisibilitybadge.component.jsx";
class CalendarListing extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            rows: [],
            headers: [],
            searchKeywords: '',
            activePage: 1,
            pageSize: 10,
            totalItemsCount: 0,
            loading: true,
            sortField: 'titleSort',
            asc: true,
        }
        this.handleSearchChange = this.handleSearchChange.bind(this)
    }

    componentDidMount() {
        SideBar.activateMenu('sales-tools')
        this.refreshSearch()
    }

    handleSearchChange(event) {
        const target = event.target;
        this.setState({
            searchKeywords: target.value
        }, () => {
            this.refreshSearch()
        })
    }

    getSearchPostData() {
        let filters = {}
        let objects = ['calendars']
        return {
            keywords: GlobalHelper.formatSearchKeywords(this.state.searchKeywords),
            objects: objects,
            fields: [
                'title',
                'titleKeyword',
                'titleAnalyzed',
            ],
            totals: [],
            pageSize: this.state.pageSize,
            activePage: this.state.activePage,
            sortByField: this.state.sortField,
            sortAsc: this.state.asc,
            filters: filters,
            lightResult: true,
        }
    }

    refreshSearch() {
        this.setState({
            loading: true,
        })
        const data = this.getSearchPostData()
        Promise.all([
            AppContext.getApiClient().post('/listing/search', data),
        ]).then(res => {
            const r = res[0]
            this.setState({
                headers: r.data.length > 0 ? this.headers() : [],
                rows: r.data.map(q => this.row(q)),
                totalItemsCount: r.metadata.totalItemsCount,
                loading: false,
            })
        })
    }

    headers() {
        return {
            classNames: ['', '', '', 'text-right'],
            data: [
                <FormattedMessage
                    id="listing.calendars.list.headers.title_label"
                    defaultMessage="Title"
                />,
                <FormattedMessage
                    id="listing.calendars.list.headers.status_label"
                    defaultMessage="Status"
                />,
                <FormattedMessage
                    id="listing.calendars.list.headers.visibility_label"
                    defaultMessage="Visibility"
                />,
                <FormattedMessage
                    id="listing.calendars.list.headers.created_at_label"
                    defaultMessage="Created at"
                />,
            ],
        }
    }

    row(item) {
        return {
            classNames: ['', '', '', 'text-right'],
            data: [
                [
                    <Link to={"/calendars/edit/" + item.id}>
                        {item.title}
                    </Link>,
                    <div>
                        <small>{item.email}</small>
                    </div>
                ],
                <CalendarStatusBadge status={item.status} />,
                <CalendarVisibilityBadge visibility={item.visibility} />,
                <FormattedDate
                    year='numeric'
                    month='long'
                    day='numeric'
                    value={new Date(item.createdAt)} />,
            ],
        }
    }

    render() {
        let list = <StandardList
            className="row pt-3"
            headers={this.state.headers}
            rows={this.state.rows}
        />
        if (this.state.loading) {
            list = <LoadingSpinner />
        }
        return (
            <div>
                <SalesToolsTabs />
                <div className="row ui-has-modules py-1">
                    <div className="col-12 ui-module mb-0">
                        <div className="row mb-0 justify-content-end">
                            <div className="col-12 col-md-4 col-lg-3 text-align-right text-truncate">

                                <Link to="/calendars/new" className="btn btn-primary btn-sm w-100">
                                    <Icon value={"plus-circle"} />
                                    <FormattedMessage
                                        id="label.listing.add_calendar_btn"
                                        defaultMessage="Add calendar"
                                    />
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                {list}
            </div>
        );
    }
}

export default CalendarListing


// WEBPACK FOOTER //
// ./src/calendar/listing.component.jsx